"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.aaaMemberNumber = aaaMemberNumber;
exports.createValidator = createValidator;
exports.currency = currency;
exports.email = email;
exports.fileRequired = fileRequired;
exports.maxLength = maxLength;
exports.minLength = minLength;
exports.phone = phone;
exports.required = required;
exports.requiredInteger = requiredInteger;
exports.requiredTrueBoolean = requiredTrueBoolean;
exports.zipCode = zipCode;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isInteger = _interopRequireDefault(require("lodash/isInteger"));

/* eslint-disable consistent-return */
var joinRules = function joinRules(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0];
  };
};

function createValidator(rules) {
  return function (data) {
    if (data === void 0) {
      data = {};
    }

    var errors = {};
    Object.keys(rules).forEach(function (key) {
      var fieldRules = joinRules(rules[key]);
      var error = fieldRules(data[key], data);

      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

function required(value) {
  if ((0, _isNil["default"])(value) || value.trim().length === 0) {
    return 'This field is required';
  }
}

function requiredInteger(value) {
  if (!(0, _isInteger["default"])(value)) {
    return 'This field is required';
  }
}

function requiredTrueBoolean(value) {
  if (value !== true) {
    return 'This field is required';
  }
}

function fileRequired(value) {
  if (!value || (0, _isNil["default"])(value) || value.length === 0) {
    return 'Please provide a file';
  }
}

function email(value) {
  if (!(0, _isNil["default"])(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.trim())) {
    return 'Please provide a valid email address';
  }
}

function phone(value) {
  var formattedPhone = (value || '').replace(/[^0-9]+/gi, '');

  if (!(formattedPhone.length >= 10 && formattedPhone.length < 12)) {
    return 'Please provide a valid phone number';
  }
}

function aaaMemberNumber(value) {
  if (!!value && !/^[0-9]+$/.test(value)) {
    return 'Please provide a valid AAA member number';
  }
}

function minLength(min) {
  return function (value) {
    if (!(0, _isEmpty["default"])(value) && value.length < min) {
      return "Please enter at least " + min + " characters.";
    }
  };
}

function maxLength(max) {
  return function (value) {
    if (!(0, _isEmpty["default"])(value) && value.length > max) {
      return "Please enter no more than " + max + " characters.";
    }
  };
}

function zipCode(value) {
  if (!!value && !/^[0-9]{5}$/.test(value)) {
    return 'Please provide a valid ZIP code';
  }
}

function currency(maximumValue) {
  return function (value) {
    if (!!value && !/^\$?[0-9]+(\.[0-9]{2})?$/.test(value)) {
      return 'Please provide a valid amount';
    }

    if (maximumValue) {
      var sanitized = parseFloat(value.replace('$', ''));

      if (sanitized > maximumValue) {
        return "Please enter an amount less than $" + maximumValue;
      }
    }
  };
}